import React, { useState, useEffect } from 'react';
import { getIncentiveList } from './Services/PayrollService';

const RunPayroll = () => {
  // ── State ─────────────────────────────────────────────────────────────
  const [currentStep, setCurrentStep] = useState(1);
  const [excluded, setExcluded] = useState({}); // eid → reason
  const [attSynced, setAttSynced] = useState(true);
  const [skipAttendance, setSkipAttendance] = useState(false);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

      const [ArrearManagementList, setArrearManagementList] = useState([]);
    
      useEffect(() => {
        getIncentiveList();
      }, []);
    
      const GetArrearList = () => {
        let params = {
          "ArrearId": 0,
           "OrgId": userDetails?.OrgId,
      "GUID": "string",
      "EmpId": userDetails?.EmpId,
          "PageNumber": 0,
          "PageSize": 0,
          "Search": "string",
          "ArrearStatusId": "string",
          "ArrearTypeId": "string",
          "LoggedInEmpId": 0
        };
        try {
          let res = getIncentiveList(params);
          setArrearManagementList(res?.Data);
        } catch (error) {
          console.error("Error fetching arrear list:", error);
        }
    
      }

  // Sample Data
  const NAMES = ['Ravindra Kumar', 'Rohit Yadav', 'Priya Sharma', 'Ankit Verma', 'Sneha Patel',
    'Vikram Singh', 'Neha Gupta', 'Arjun Mehta', 'Deepa Rao', 'Sanjay Kumar',
    'Pooja Agarwal', 'Rahul Mishra', 'Kavita Joshi', 'Amit Tiwari', 'Sunita Devi',
    'Ravi Shankar', 'Ananya Nair', 'Manish Pandey', 'Divya Sinha', 'Rajesh Yadav'];

  const DEPTS = ['Engineering', 'Engineering', 'Product', 'Design', 'Operations', 'HR', 'Finance', 'Engineering', 'Product', 'Engineering', 'Engineering', 'Product', 'Design', 'Operations', 'HR', 'Finance', 'Engineering', 'Product', 'Engineering', 'Engineering'];
  const ROLES = ['Sr. Engineer', 'Engineer', 'Product Manager', 'UI Designer', 'Ops Lead', 'HR Manager', 'Accountant', 'Tech Lead', 'Product Analyst', 'DevOps Eng.', 'Sr. Engineer', 'Engineer', 'Product Manager', 'UI Designer', 'Ops Lead', 'HR Manager', 'Accountant', 'Tech Lead', 'Product Analyst', 'DevOps Eng.'];
  const MODES = ['account', 'account', 'account', 'cash', 'account', 'account', 'later', 'account', 'account', 'account', 'account', 'account', 'cash', 'account', 'account', 'account', 'later', 'account', 'account', 'account'];

  const [employees] = useState(() =>
    NAMES.map((name, i) => {
      const eid = `OG${String(54 + i).padStart(4, '0')}`;
      const base = 55000 + i * 4800;
      const awd = 28 + Math.floor(Math.random() * 3);
      const lop = Math.random() > 0.8 ? Math.floor(Math.random() * 3) + 1 : 0;
      const salary = Math.round(base * (awd / 31));
      const pf_ee = Math.min(1800, Math.round(salary * 0.40 * 0.12));
      const esic_ee = salary <= 21000 ? Math.round(salary * 0.0075) : 0;
      const pt = 200;
      const tds = Math.max(0, Math.round((salary * 12 - 700000) * 0.15 / 12));
      const food = Math.random() > 0.6 ? 1500 : 0;

      return {
        i: i + 1,
        eid,
        name,
        dept: DEPTS[i],
        role: ROLES[i],
        mode: MODES[i],
        base,
        awd,
        lop,
        salary,
        pf_ee,
        esic_ee,
        pt,
        tds,
        food,
      };
    })
  );

  const [loans] = useState([
    { eid: 'OG0055', name: 'Rohit Yadav', type: 'Personal Loan', total: 120000, repaid: 40000, tenure: 24, balTenure: 16, emi: 5000 },
    { eid: 'OG0057', name: 'Ankit Verma', type: 'Vehicle Advance', total: 60000, repaid: 12000, tenure: 12, balTenure: 8, emi: 6000 },
    { eid: 'OG0058', name: 'Sneha Patel', type: 'Personal Loan', total: 80000, repaid: 20000, tenure: 16, balTenure: 12, emi: 5000 },
    { eid: 'OG0058', name: 'Sneha Patel', type: 'Salary Advance', total: 15000, repaid: 5000, tenure: 3, balTenure: 2, emi: 5000 },
    { eid: 'OG0061', name: 'Arjun Mehta', type: 'Personal Loan', total: 200000, repaid: 80000, tenure: 24, balTenure: 12, emi: 10000 },
  ]);

  const [arrears, setArrears] = useState([
    { eid: 'OG0054', name: 'Ravindra Kumar', type: 'Salary Revision', month: 'Feb 2025', total: 12000, paid: 0, status: 'Open' },
    { eid: 'OG0056', name: 'Priya Sharma', type: 'Backdated Increment', month: 'Jan 2025', total: 18000, paid: 9000, status: 'Partially Paid' },
    { eid: 'OG0060', name: 'Sanjay Kumar', type: 'Missed Payment', month: 'Dec 2024', total: 8500, paid: 0, status: 'Open' },
  ]);

  const [incentives, setIncentives] = useState([
    { eid: 'OG0054', name: 'Ravindra Kumar', type: 'Performance Incentive', desc: 'Q4 FY24-25', total: 25000, paid: 0, status: 'Open' },
    { eid: 'OG0059', name: 'Deepa Rao', type: 'Variable Pay', desc: 'Annual Var', total: 40000, paid: 20000, status: 'Partially Paid' },
    { eid: 'OG0056', name: 'Priya Sharma', type: 'Retention Bonus', desc: '2-yr retention', total: 15000, paid: 0, status: 'Open' },
    { eid: 'OG0058', name: 'Sneha Patel', type: 'Sales Commission', desc: 'Mar targets', total: 8000, paid: 0, status: 'Open' },
  ]);

  const [reimbs, setReimbs] = useState([
    { eid: 'OG0054', name: 'Ravindra Kumar', type: 'Meal', desc: 'Monthly meal', amount: 2200 },
    { eid: 'OG0054', name: 'Ravindra Kumar', type: 'Internet', desc: 'Home internet', amount: 500 },
    { eid: 'OG0055', name: 'Rohit Yadav', type: 'Fuel', desc: 'Client travel', amount: 3500 },
    { eid: 'OG0055', name: 'Rohit Yadav', type: 'Mobile', desc: 'Monthly mobile', amount: 500 },
    { eid: 'OG0056', name: 'Priya Sharma', type: 'LTA', desc: 'Leave travel', amount: 12000 },
    { eid: 'OG0057', name: 'Ankit Verma', type: 'Meal', desc: 'Monthly meal', amount: 2200 },
    { eid: 'OG0058', name: 'Sneha Patel', type: 'Meal', desc: 'Monthly meal', amount: 2200 },
    { eid: 'OG0058', name: 'Sneha Patel', type: 'Internet', desc: 'Home internet', amount: 500 },
    { eid: 'OG0059', name: 'Deepa Rao', type: 'Books & Education', desc: 'Course fee', amount: 2000 },
  ]);

  const [lopData] = useState([
    { name: 'Rohit Yadav', dept: 'Product', dates: '3, 7 Mar 2025', days: 2, reason: 'Unplanned leave' },
    { name: 'Sneha Patel', dept: 'Operations', dates: '14 Mar 2025', days: 1, reason: 'Absent — no information' },
    { name: 'Arjun Mehta', dept: 'Engineering', dates: '5, 6, 7 Mar 2025', days: 3, reason: 'Unauthorised absence' },
    { name: 'Sanjay Kumar', dept: 'Engineering', dates: '20, 21 Mar 2025', days: 2, reason: 'Absent — no information' },
    { name: 'Pooja Agarwal', dept: 'Finance', dates: '12 Mar 2025', days: 1, reason: 'Unplanned leave' },
    { name: 'Rahul Mishra', dept: 'Product', dates: '2, 3, 4 Mar 2025', days: 3, reason: 'Unauthorised absence' },
    { name: 'Kavita Joshi', dept: 'Design', dates: '18 Mar 2025', days: 1, reason: 'Absent — no information' },
    { name: 'Amit Tiwari', dept: 'Operations', dates: '25 Mar 2025', days: 1, reason: 'Unplanned leave' },
  ]);

  const [reviewData, setReviewData] = useState([]);
  const [reviewCurrentPage, setReviewCurrentPage] = useState(1);
  const REVIEW_PER_PAGE = 10;

  const [payrollApproved, setPayrollApproved] = useState(false);
  const [payModes, setPayModes] = useState(MODES);

  // Modal States
  const [showArrearModal, setShowArrearModal] = useState(false);
  const [showIncentModal, setShowIncentModal] = useState(false);
  const [showReimbModal, setShowReimbModal] = useState(false);
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [showWarnModal, setShowWarnModal] = useState(false);
  const [warnTitle, setWarnTitle] = useState('');
  const [warnMsg, setWarnMsg] = useState('');
  const [warnOnOk, setWarnOnOk] = useState(null);

  // ── Helpers ───────────────────────────────────────────────────────────
  const openModal = (setter) => setter(true);
  const closeModal = (setter) => setter(false);

  // Pre-build review data on mount
  useEffect(() => {
    const incl = employees.filter(e => !excluded[e.eid]);
    const arrearMap = {};
    const incentMap = {};
    const reimbMap = {};
    const loanMap = {};

    arrears.forEach(a => {
      arrearMap[a.eid] = (arrearMap[a.eid] || 0) + a.total;
    });
    incentives.forEach(v => {
      incentMap[v.eid] = (incentMap[v.eid] || 0) + v.total;
    });
    reimbs.forEach(r => {
      reimbMap[r.eid] = (reimbMap[r.eid] || 0) + r.amount;
    });
    loans.forEach(l => {
      loanMap[l.eid] = (loanMap[l.eid] || 0) + l.emi;
    });

    const data = incl.map(e => {
      const arr = arrearMap[e.eid] || 0;
      const inc = incentMap[e.eid] || 0;
      const rei = reimbMap[e.eid] || 0;
      const loan = loanMap[e.eid] || 0;
      const other = e.food || 0;
      const net = e.salary + arr + inc + rei - e.pf_ee - e.esic_ee - e.pt - e.tds - loan - other;
      return { e, arr, inc, rei, loan, other, net };
    });

    setReviewData(data);
  }, [employees, excluded, arrears, incentives, reimbs, loans]);

  const goToStep = (n) => {
    setCurrentStep(n);
    if (n === 7) buildReview();
    if (n === 8) buildRegister();
  };

  const nextStep = () => {
    if (currentStep < 8) goToStep(currentStep + 1);
  };

  const prevStep = () => {
    if (currentStep > 1) goToStep(currentStep - 1);
  };

  // Step 1: Exclusions
  const refreshExclusions = () => {
    // Handled via state reactivity
  };

  const [selectedExclEid, setSelectedExclEid] = useState('');
  const [exclSearch, setExclSearch] = useState('');
  const [exclReason, setExclReason] = useState('');

  const filteredEmployeesForExcl = employees.filter(
    (e) => !excluded[e.eid] &&
      (e.name.toLowerCase().includes(exclSearch.toLowerCase()) || e.eid.includes(exclSearch))
  ).slice(0, 8);

  const addExclusion = () => {
    if (!selectedExclEid) {
      alert('Please search and select an employee first.');
      return;
    }
    if (!exclReason) {
      alert('Please select a reason for exclusion.');
      return;
    }
    setExcluded((prev) => ({ ...prev, [selectedExclEid]: exclReason }));
    setSelectedExclEid('');
    setExclSearch('');
    setExclReason('');
  };

  const removeExclusion = (eid) => {
    setExcluded((prev) => {
      const newEx = { ...prev };
      delete newEx[eid];
      return newEx;
    });
  };

  const selectExcl = (eid, name) => {
    setSelectedExclEid(eid);
    setExclSearch(name);
  };

  // Step 2: Attendance
  const toggleAttSync = (e) => {
    setSkipAttendance(e.target.checked);
  };

  const syncAttendance = () => {
    const btn = document.getElementById('syncBtn');
    if (btn) {
      btn.innerHTML = '<i className="fa-solid fa-rotate fa-spin"></i> Syncing…';
      btn.disabled = true;
    }

    setTimeout(() => {
      setAttSynced(true);
      if (btn) {
        btn.innerHTML = '<i className="fa-solid fa-check"></i> Re-sync';
        btn.disabled = false;
        btn.className = 'btn btn-light btn-sm';
      }
      // Summary is shown via state
    }, 1200);
  };

  const removeLOP = (index) => {
    alert(`LOP record ${index + 1} removed (demo)`);
  };

  // Step 3: Loans
  const [loanFinals, setLoanFinals] = useState(loans.map(l => l.emi));
  const [loanChecks, setLoanChecks] = useState(loans.map(() => true));

  const recalcLoanTotal = () => {
    let emiSum = 0;
    let finalSum = 0;

    loans.forEach((l, i) => {
      if (loanChecks[i]) {
        emiSum += l.emi;
        finalSum += loanFinals[i] || 0;
      }
    });

    return { emiSum, finalSum };
  };

  const handleLoanFinalChange = (index, value) => {
    const newFinals = [...loanFinals];
    newFinals[index] = parseInt(value) || 0;
    setLoanFinals(newFinals);
  };

  const handleLoanCheckChange = (index) => {
    const newChecks = [...loanChecks];
    newChecks[index] = !newChecks[index];
    setLoanChecks(newChecks);
  };

  const { emiSum: loanEmiTotal, finalSum: loanFinalTotal } = recalcLoanTotal();

  // Step 4: Arrears
  const [arrearChecks, setArrearChecks] = useState(arrears.map(() => true));

  const recalcArrear = () => {
    let total = 0;
    arrears.forEach((a, i) => {
      if (arrearChecks[i]) total += a.total;
    });
    return total;
  };

  const arrearTotal = recalcArrear();

  const showAddArrear = () => openModal(setShowArrearModal);

  const saveArrear = () => {
    const empSelect = document.getElementById('ma-emp');
    if (!empSelect) return;
    const emp = employees.find(e => e.eid === empSelect.value);
    const amt = parseInt(document.getElementById('ma-amount')?.value) || 0;

    if (!emp || !amt) {
      alert('Please fill all required fields.');
      return;
    }

    setArrears(prev => [...prev, {
      eid: emp.eid,
      name: emp.name,
      type: 'Other',
      month: 'Mar 2025',
      total: amt,
      paid: 0,
      status: 'Open'
    }]);

    setArrearChecks(prev => [...prev, true]);
    closeModal(setShowArrearModal);
  };

  // Step 5: Incentives
  const [incentChecks, setIncentChecks] = useState(incentives.map(() => true));

  const recalcIncent = () => {
    let total = 0;
    incentives.forEach((v, i) => {
      if (incentChecks[i]) total += v.total;
    });
    return total;
  };

  const incentTotal = recalcIncent();

  const showAddIncentive = () => openModal(setShowIncentModal);

  const saveIncentive = () => {
    const empSelect = document.getElementById('mi-emp');
    if (!empSelect) return;
    const emp = employees.find(e => e.eid === empSelect.value);
    const amt = parseInt(document.getElementById('mi-amount')?.value) || 0;

    if (!emp || !amt) {
      alert('Please fill all required fields.');
      return;
    }

    setIncentives(prev => [...prev, {
      eid: emp.eid,
      name: emp.name,
      type: 'Other',
      desc: 'Manual entry',
      total: amt,
      paid: 0,
      status: 'Open'
    }]);

    setIncentChecks(prev => [...prev, true]);
    closeModal(setShowIncentModal);
  };

  // Step 6: Reimbursements
  const [reimbChecks, setReimbChecks] = useState(reimbs.map(() => true));

  const recalcReimb = () => {
    let total = 0;
    reimbs.forEach((r, i) => {
      if (reimbChecks[i]) total += r.amount;
    });
    return total;
  };

  const reimbTotal = recalcReimb();

  const showAddReimb = () => openModal(setShowReimbModal);

  const saveReimb = () => {
    const empSelect = document.getElementById('mr-emp');
    if (!empSelect) return;
    const emp = employees.find(e => e.eid === empSelect.value);
    const amt = parseInt(document.getElementById('mr-amount')?.value) || 0;

    if (!emp || !amt) {
      alert('Please fill all required fields.');
      return;
    }

    setReimbs(prev => [...prev, {
      eid: emp.eid,
      name: emp.name,
      type: 'Other',
      desc: 'Manual entry',
      amount: amt
    }]);

    setReimbChecks(prev => [...prev, true]);
    closeModal(setShowReimbModal);
  };

  // Step 7: Review
  const buildReview = () => {
    const incl = employees.filter(e => !excluded[e.eid]);

    const arrearMap = {};
    const incentMap = {};
    const reimbMap = {};
    const loanMap = {};

    arrears.forEach(a => {
      arrearMap[a.eid] = (arrearMap[a.eid] || 0) + a.total;
    });
    incentives.forEach(v => {
      incentMap[v.eid] = (incentMap[v.eid] || 0) + v.total;
    });
    reimbs.forEach(r => {
      reimbMap[r.eid] = (reimbMap[r.eid] || 0) + r.amount;
    });
    loans.forEach(l => {
      loanMap[l.eid] = (loanMap[l.eid] || 0) + l.emi;
    });

    let tot = { base: 0, salary: 0, pf: 0, esic: 0, arrear: 0, incent: 0, reimb: 0, loan: 0, other: 0, tds: 0, net: 0 };

    const data = incl.map(e => {
      const arr = arrearMap[e.eid] || 0;
      const inc = incentMap[e.eid] || 0;
      const rei = reimbMap[e.eid] || 0;
      const loan = loanMap[e.eid] || 0;
      const other = e.food || 0;
      const net = e.salary + arr + inc + rei - e.pf_ee - e.esic_ee - e.pt - e.tds - loan - other;

      tot.base += e.base;
      tot.salary += e.salary;
      tot.pf += e.pf_ee;
      tot.esic += e.esic_ee;
      tot.arrear += arr;
      tot.incent += inc;
      tot.reimb += rei;
      tot.loan += loan;
      tot.other += other;
      tot.tds += e.tds;
      tot.net += net;

      return { e, arr, inc, rei, loan, other, net };
    });

    setReviewData(data);
    setReviewCurrentPage(1);
  };

  const renderReviewPage = () => {
    if (!reviewData || reviewData.length === 0) return [];
    const start = (reviewCurrentPage - 1) * REVIEW_PER_PAGE;
    const end = Math.min(start + REVIEW_PER_PAGE, reviewData.length);
    return reviewData.slice(start, end).map((row, idx) => {
      const empIndex = employees.findIndex(e => e.eid === row.e.eid);
      const currentMode = payModes[empIndex] || 'account';
      return (
        <tr key={idx}>
          <td style={{ fontWeight: '600' }}>{row.e.name}</td>
          <td className="tr">31</td>
          <td className="tr">₹{(row.e.base || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.e.salary || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.e.pf_ee || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.e.esic_ee || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.arr || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.inc || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.rei || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.loan || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.other || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(row.e.tds || 0).toLocaleString('en-IN')}</td>
          <td className="tr" style={{ color: 'var(--brand)', fontWeight: '600' }}>₹{(row.net || 0).toLocaleString('en-IN')}</td>
          <td style={{ textAlign: 'center', minWidth: '130px' }}>
            <div style={{ display: 'flex', gap: '3px', justifyContent: 'center' }}>
              <button
                className="pay-mode-btn account sel"
                onClick={() => setPayMode(row.e.eid, 'account')}
              >
                Acct
              </button>
              <button
                className="pay-mode-btn cash"
                onClick={() => setPayMode(row.e.eid, 'cash')}
              >
                Cash
              </button>
              <button
                className="pay-mode-btn later"
                onClick={() => setPayMode(row.e.eid, 'later')}
              >
                Later
              </button>
            </div>
          </td>
        </tr>
      );
    });
  };

  const reviewPage = (dir) => {
    const totalPages = Math.ceil(reviewData.length / REVIEW_PER_PAGE);
    let newPage = reviewCurrentPage + dir;
    newPage = Math.max(1, Math.min(totalPages, newPage));
    setReviewCurrentPage(newPage);
  };

  const setPayMode = (eid, mode) => {
    const empIndex = employees.findIndex(e => e.eid === eid);
    if (empIndex >= 0) {
      const newModes = [...payModes];
      newModes[empIndex] = mode;
      setPayModes(newModes);
    }
  };

  // Step 8: Register
  const buildRegister = () => {
    const incl = employees.filter(e => !excluded[e.eid]);
    return incl.map((e, idx) => {
      const empModeIdx = employees.findIndex(emp => emp.eid === e.eid);
      const payMode = payModes[empModeIdx] || 'account';
      const arrearAmt = arrears.filter(a => a.eid === e.eid).reduce((a, v) => a + v.total, 0) || 0;
      const incentAmt = incentives.filter(v => v.eid === e.eid).reduce((a, v) => a + v.total, 0) || 0;
      const reimbAmt = reimbs.filter(r => r.eid === e.eid).reduce((a, r) => a + r.amount, 0) || 0;
      const loanAmt = loans.filter(l => l.eid === e.eid).reduce((a, l) => a + l.emi, 0) || 0;
      const grossSalary = (e.salary || 0) + arrearAmt + incentAmt + reimbAmt;
      const netPayable = grossSalary - (e.pf_ee || 0) - (e.esic_ee || 0) - (e.pt || 0) - (e.tds || 0) - loanAmt;
      return (
        <tr key={idx}>
          <td>{e.eid}</td>
          <td style={{ fontWeight: '600' }}>{e.name}</td>
          <td style={{ fontSize: '11.5px', color: 'var(--text-muted)' }}>{e.dept} / {e.role}</td>
          <td className="tr">31</td>
          <td className="tr">₹{(e.base || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(e.salary || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{arrearAmt.toLocaleString('en-IN')}</td>
          <td className="tr">₹{incentAmt.toLocaleString('en-IN')}</td>
          <td className="tr">₹{reimbAmt.toLocaleString('en-IN')}</td>
          <td className="tr fw-bold">₹{grossSalary.toLocaleString('en-IN')}</td>
          <td className="tr">₹{(e.pf_ee || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(e.esic_ee || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(e.pt || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{(e.tds || 0).toLocaleString('en-IN')}</td>
          <td className="tr">₹{loanAmt.toLocaleString('en-IN')}</td>
          <td className="tr">₹0</td>
          <td className="tr fw-bold" style={{ color: 'var(--brand)' }}>₹{netPayable.toLocaleString('en-IN')}</td>
          <td style={{ textAlign: 'center', minWidth: '130px' }}>
            <div style={{ display: 'flex', gap: '3px', justifyContent: 'center' }}>
              <button
                className="pay-mode-btn account sel"
                onClick={() => setPayMode(e.eid, 'account')}
              >
                Acct
              </button>
              <button
                className="pay-mode-btn cash"
                onClick={() => setPayMode(e.eid, 'cash')}
              >
                Cash
              </button>
              <button
                className="pay-mode-btn later"
                onClick={() => setPayMode(e.eid, 'later')}
              >
                Later
              </button>
            </div>
          </td>
          <td style={{ textAlign: 'center' }}>
            <button className="payslip-action">
              <i className="fa-regular fa-file-lines"></i></button></td>
        </tr>
      );
    });
  };

  const approvePayroll = () => {
    setPayrollApproved(true);
  };

  const openHistory = () => {
    openModal(setShowHistoryModal);
  };

  const downloadExcel = () => {
    console.log('Download Excel clicked');
  };

  const downloadBank = () => {
    console.log('Download Bank Format clicked');
  };

  // History Modal Content
  const getHistoryContent = () => {
    const inclCount = employees.length - Object.keys(excluded).length;
    const lopCount = lopData.length;
    const loanTotal = loans.reduce((a, l) => a + l.emi, 0);
    const arrTotal = arrears.reduce((a, v) => a + (v.total - v.paid), 0);
    const incTotal = incentives.reduce((a, v) => a + (v.total - v.paid), 0);
    const rebTotal = reimbs.reduce((a, r) => a + r.amount, 0);

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {[
          {
            step: 'Step 1 — Confirm Employees',
            icon: 'fa-users',
            color: '#EC4119',
            items: [
              `${inclCount} employees in payroll`,
              `${Object.keys(excluded).length} excluded`,
              ...Object.entries(excluded).map(([eid, r]) => {
                const e = employees.find(x => x.eid === eid);
                return `• ${e?.name} — ${r}`;
              })
            ]
          },
          {
            step: 'Step 2 — Attendance & LOP',
            icon: 'fa-calendar-check',
            color: '#3b82f6',
            items: [attSynced ? `Attendance synced — ${lopCount} LOP records, 14 days total` : 'Attendance skipped — full days for all']
          },
          {
            step: 'Step 3 — Loans & Advances',
            icon: 'fa-hand-holding-dollar',
            color: '#8b5cf6',
            items: [`${loans.length} loan records`, `Total deduction: ₹${loanTotal.toLocaleString('en-IN')}`]
          },
          {
            step: 'Step 4 — Arrears',
            icon: 'fa-rotate-left',
            color: '#f59e0b',
            items: [`${arrears.length} arrear records`, `Total: ₹${arrTotal.toLocaleString('en-IN')}`]
          },
          {
            step: 'Step 5 — Incentives',
            icon: 'fa-trophy',
            color: '#10b981',
            items: [`${incentives.length} incentive records`, `Total: ₹${incTotal.toLocaleString('en-IN')}`]
          },
          {
            step: 'Step 6 — Reimbursements',
            icon: 'fa-receipt',
            color: '#06b6d4',
            items: [`${reimbs.length} reimbursement claims`, `Total: ₹${rebTotal.toLocaleString('en-IN')}`]
          },
          {
            step: 'Step 7 — Review',
            icon: 'fa-eye',
            color: '#64748b',
            items: ['Reviewed and payment modes set']
          },
        ].map((s, idx) => (
          <div key={idx} style={{ display: 'flex', gap: '12px', padding: '12px', background: '#f8f9fa', borderRadius: '8px' }}>
            <div style={{ width: '32px', height: '32px', borderRadius: '8px', background: `${s.color}1a`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, color: s.color }}>
              <i className={`fa-solid ${s.icon}`} style={{ fontSize: '14px' }}></i>
            </div>
            <div>
              <div style={{ fontSize: '12.5px', fontWeight: 700, color: 'var(--text-dark)', marginBottom: '4px' }}>{s.step}</div>
              {s.items.map((item, i) => (
                <div key={i} style={{ fontSize: '11.5px', color: 'var(--text-muted)' }}>{item}</div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // ── Render ────────────────────────────────────────────────────────────
  const inclCount = employees.length - Object.keys(excluded).length;

  return (
    <div className="container-fluid">

      <div className="page-content">
        <div className="page-header">
          <div>
            <h1 className="page-title">Run Payroll — March 2025</h1>
            <p className="page-subtitle">Follow steps to confirm, compute and push salaries for all employees</p>
          </div>
          <div className="page-header-right">
            <span style={{ fontSize: '12px', fontWeight: '600', color: 'var(--text-muted)', background: '#f1f3f5', padding: '4px 12px', borderRadius: '100px' }}>
              <i className="fa-regular fa-calendar me-1"></i>March 2025
            </span>
            <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '8px', padding: '7px 14px', fontSize: '12px', color: '#9a3412' }}>
              <i className="fa-solid fa-users me-1"></i><strong>{inclCount}</strong> employees · 31 working days
            </div>
            <button className="btn btn-light btn-sm" onClick={() => window.location.href = 'Salary-Register'}>
              <i className="fa-solid fa-arrow-left"></i> Back
            </button>
          </div>
        </div>

        {/* Stepper */}
        <div className="stepper" id="stepper">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((n, idx) => (
            <div
              key={n}
              className={`step-item ${currentStep === n ? 'active' : currentStep > n ? 'completed' : ''}`}
              data-step={n}
              onClick={() => goToStep(n)}
            >
              <div className="step-circle">{n}</div>
              <div className="step-label">
                {n === 1 && 'Confirm Employees'}
                {n === 2 && 'Attendance & LOP'}
                {n === 3 && 'Loans & Advances'}
                {n === 4 && 'Arrears'}
                {n === 5 && 'Incentives'}
                {n === 6 && 'Reimbursements'}
                {n === 7 && 'Review'}
                {n === 8 && 'Salary Register'}
              </div>
            </div>
          ))}
        </div>

        {/* Step Panels */}
        {currentStep === 1 && (
          <div className={`step-panel ${currentStep === 1 ? 'active' : ''}`} id="step1">
            {/* ... (Full Step 1 content - same structure as original) */}
            {/* I have kept the structure identical for design fidelity */}
            <div className="sp-card">
              <div className="sp-head">
                <div style={{ width: '34px', height: '34px', borderRadius: '50%', background: 'var(--brand-soft)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--brand)', fontWeight: '800' }}>1</div>
                <div>
                  <h5>Confirm Employees in Payroll Cycle</h5>
                  <p>All active employees are included by default. Exclude employees if required with a reason.</p>
                </div>
              </div>
              <div className="sp-body">
                <div style={{ display: 'flex', gap: '12px', marginBottom: '18px' }}>
                  <div className="stat-box" style={{ borderLeft: '3px solid var(--brand)' }}>
                    <div className="stat-box-label">Total Active</div>
                    <div className="stat-box-val">{employees.length}</div>
                  </div>
                  <div className="stat-box" style={{ borderLeft: '3px solid var(--success)' }}>
                    <div className="stat-box-label">In This Payroll</div>
                    <div className="stat-box-val text-success">{inclCount}</div>
                  </div>
                  <div className="stat-box" style={{ borderLeft: '3px solid var(--danger)' }}>
                    <div className="stat-box-label">Excluded</div>
                    <div className="stat-box-val" style={{ color: 'var(--danger)' }}>{Object.keys(excluded).length}</div>
                  </div>
                </div>

                {/* Exclude Form */}
                <div style={{ background: '#fafbfc', border: '1px solid var(--border)', borderRadius: '8px', padding: '14px 16px', marginBottom: '16px' }}>
                  <p style={{ margin: '0 0 10px', fontSize: '12.5px', fontWeight: '700', color: 'var(--text-dark)' }}>
                    <i className="fa-solid fa-user-minus me-1 text-brand"></i>Exclude an Employee from This Payroll
                  </p>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'flex-end' }}>
                    <div style={{ position: 'relative' }}>
                      <label className="form-label">Search Employee</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Type name or ID…"
                        style={{ width: '240px' }}
                        value={exclSearch}
                        onChange={(e) => setExclSearch(e.target.value)}
                        onFocus={() => { }}
                      />
                      {exclSearch && (
                        <div style={{ position: 'absolute', background: '#fff', border: '1px solid var(--border)', borderRadius: '6px', width: '240px', maxHeight: '180px', overflowY: 'auto', zIndex: 100, boxShadow: 'var(--shadow-md)' }}>
                          {filteredEmployeesForExcl.length > 0 ? (
                            filteredEmployeesForExcl.map(e => (
                              <div
                                key={e.eid}
                                style={{ padding: '8px 12px', cursor: 'pointer', fontSize: '12.5px', borderBottom: '1px solid #f0f2f5' }}
                                onClick={() => selectExcl(e.eid, e.name)}
                              >
                                <span style={{ fontWeight: '600' }}>{e.name}</span>
                                <span style={{ color: 'var(--text-muted)', fontSize: '11px', marginLeft: '6px' }}>{e.eid} · {e.dept}</span>
                              </div>
                            ))
                          ) : (
                            <div style={{ padding: '8px 12px', fontSize: '12px', color: 'var(--text-muted)' }}>No matching employee</div>
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="form-label">Reason</label>
                      <select className="form-select" style={{ width: '200px' }} value={exclReason} onChange={(e) => setExclReason(e.target.value)}>
                        <option value="">Select reason…</option>
                        <option>Resignation</option>
                        <option>Contract Ended</option>
                        <option>Salary on Hold</option>
                        <option>Joining Mid-month (next cycle)</option>
                        <option>Other</option>
                      </select>
                    </div>
                    <button className="btn theme-color btn-sm" onClick={addExclusion} style={{ marginBottom: '1px' }}>
                      <i className="fa-solid fa-minus-circle"></i> Exclude
                    </button>
                  </div>
                </div>

                {/* Exclusion List */}
                {Object.keys(excluded).length > 0 && (
                  <div id="exclListWrap">
                    <p style={{ fontSize: '12px', fontWeight: '700', color: 'var(--text-mid)', margin: '0 0 8px' }}>
                      <i className="fa-solid fa-user-slash me-1 text-brand"></i>Excluded Employees
                    </p>
                    <div style={{ border: '1px solid #fecaca', borderRadius: '8px', overflow: 'hidden' }}>
                      <table className="stbl">
                        <thead>
                          <tr>
                            <th>Employee</th><th>Department</th><th>Role</th><th>Reason</th>
                            <th style={{ textAlign: 'center' }}>Remove Exclusion</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(excluded).map(eid => {
                            const emp = employees.find(e => e.eid === eid);
                            return (
                              <tr key={eid} style={{ background: '#fff5f5' }}>
                                <td><span style={{ fontWeight: '600' }}>{emp?.name}</span><br /><code style={{ fontSize: '10px', color: 'var(--brand)' }}>{eid}</code></td>
                                <td style={{ fontSize: '11.5px', color: 'var(--text-muted)' }}>{emp?.dept}</td>
                                <td style={{ fontSize: '11.5px' }}>{emp?.role}</td>
                                <td><span className="badge badge-failed">{excluded[eid]}</span></td>
                                <td style={{ textAlign: 'center' }}>
                                  <button className="btn btn-light btn-sm" onClick={() => removeExclusion(eid)}>
                                    <i className="fa-solid fa-rotate-left" style={{ color: 'var(--success)' }}></i> Restore
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {Object.keys(excluded).length === 0 && (
                  <div id="exclEmptyMsg" style={{ background: '#f8f9fa', border: '1px dashed var(--border)', borderRadius: '8px', padding: '20px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '12.5px' }}>
                    <i className="fa-solid fa-users" style={{ fontSize: '24px', marginBottom: '8px', color: '#ddd', display: 'block' }}></i>
                    All <strong>{employees.length}</strong> active employees are included in this payroll cycle.<br />
                    Use the form above to exclude anyone if needed.
                  </div>
                )}
              </div>
            </div>

            <div className="step-nav">
              <span></span>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-arrow-right"></i> Next: Attendance &amp; LOP
              </button>
            </div>
          </div>
        )}

        {/* Other steps follow the same pattern - full code is very long, so I've shown the structure for Step 1 fully. */}
        {/* For brevity in this response, the remaining steps (2-8) follow exactly the same HTML structure but converted to JSX with React state. */}

        {/* Example for Step 2 (shortened for space) */}
        {/* {currentStep === 2 && (
          <div className={`step-panel ${currentStep === 2 ? 'active' : ''}`} id="step2">
            <div className="sp-card">
              <div className="sp-head">
                <div style={{ 'width': '34px', 'height': '34px', 'borderRadius': '50%', 'background': 'var(--brand-soft)', 'display': 'flex', 'alignItems': 'center', 'justifyContent': 'center', 'color': 'var(--brand)', 'fontWeight': '800' }}>2</div>
                <div><h5>Attendance &amp; LOP</h5><p>Sync attendance data to compute payable days. Skip to consider all 31 days for all employees.</p></div>
                <div style={{ 'marginLeft': 'auto', 'display': 'flex', 'alignItems': 'center', 'gap': '10px' }}>
                  <span style={{ 'fontSize': '12.5px', 'fontWeight': '600', 'color': 'var(--text-mid)' }}>Skip attendance (pay full days)</span>
                  <label className="tog"><input type="checkbox" id="skipAtt" onchange="toggleAttSync()" /><span className="tog-slider"></span></label>
                </div>
              </div>
              <div className="sp-body" id="attBody">
                <div id="attSyncPanel">
                  <div style={{ 'display': 'flex', 'gap': '10px', 'margin-bottom': '16px', 'alignItems': 'center' }}>
                    <button className="btn btn-brand btn-sm" onclick="syncAttendance()"><i className="fa-solid fa-rotate"></i> Sync Attendance Data</button>
                    <span style={{ 'fontSize': '12px', 'color': 'var(--text-muted)' }} id="attSyncStatus">Not yet synced</span>
                  </div>
                  <div id="attSummaryRow" style={{ 'display': 'none', 'gap': '12px', 'margin-bottom': '18px' }} className="d-flex">
                    <div className="stat-box" style={{ 'borderLeft': '3px solid var(--success)' }}><div className="stat-box-label">Full Attendance</div><div className="stat-box-val" id="att-full">—</div></div>
                    <div className="stat-box" style={{ 'borderLeft': '3px solid var(--danger)' }}><div className="stat-box-label">With LOP</div><div className="stat-box-val" style={{ 'color': 'var(--danger)' }} id="att-lop">—</div></div>
                    <div className="stat-box" style={{ 'borderLeft': '3px solid var(--info)' }}><div className="stat-box-label">On Leave</div><div className="stat-box-val" id="att-leave">—</div></div>
                    <div className="stat-box" style={{ 'borderLeft': '3px solid var(--brand)' }}><div className="stat-box-label">Total LOP Days</div><div className="stat-box-val text-brand" id="att-lop-days">—</div></div>
                  </div>
                  <div id="attLopGrid" style={{ 'display': 'none' }}>
                    <div style={{ 'display': 'flex', 'alignItems': 'center', 'gap': '10px', 'margin-bottom': '10px' }}>
                      <h6 style={{ 'margin': '0', 'fontSize': '13px', 'fontWeight': '700' }}><i className="fa-solid fa-calendar-xmark me-1 text-brand"></i>LOP Records (Finalized)</h6>
                      <span style={{ 'fontSize': '11.5px', 'color': 'var(--text-muted)' }}>Remove any record to exclude it from LOP calculation</span>
                    </div>
                    <div style={{ border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
                      <table className="stbl" id="lopTable">
                        <thead>
                          <tr>
                            <th>Employee</th><th>Department</th><th>LOP Date(s)</th><th>Days</th><th>Reason</th><th style={{ textAlign: 'center' }}>Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lopData.map((r, i) => (
                            <tr key={i}>\n                              <td style={{fontWeight:'600'}}>{r.name}</td>\n                              <td style={{fontSize:'11.5px',color:'var(--text-muted)'}}>{r.dept}</td>\n                              <td style={{fontSize:'12px'}}>{r.dates}</td>\n                              <td className=\"tr\"><span className=\"lop-badge\">{r.days} day{r.days > 1 ? 's' : ''}</span></td>\n                              <td style={{fontSize:'12px',color:'var(--text-muted)'}}>{r.reason}</td>\n                              <td style={{textAlign:'center'}}>\n                                <button className=\"btn btn-light btn-sm\" onClick={() => removeLOP(i)}>\n                                  <i className=\"fa-solid fa-trash\" style={{color:'var(--danger)'}}></i>\n                                </button>\n                              </td>\n                            </tr>\n                          ))}\n                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div id="attSkipPanel" style="display:none">
                  <div className="alert alert-info"><i className="fa-solid fa-circle-info"></i> Attendance skipped — all <strong>31 days</strong> will be considered as payable days for all employees. No LOP will be applied.</div>
                </div>
              </div>
            </div>
            <div className="step-nav">
              <button className="btn btn-light" onClick={nextStep}><i className="fa-solid fa-arrow-left"></i> Back</button>
              <button className="btn btn-brand" onClick={prevStep}><i className="fa-solid fa-arrow-right"></i> Next: Loans &amp; Advances</button>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className={`step-panel ${currentStep === 3 ? 'active' : ''}`} id="step3">
          <div className="sp-card">
        <div className="sp-head">
          <div style={{"width":"34px","height":"34px","borderRadius":"50%","background":"var(--brand-soft)","display":"flex","alignItems":"center","justifyContent":"center","color":"var(--brand)","font-weight":"800"}}>3</div>
          <div><h5>Loans Advances</h5><p>Each loan and advance shown separately. Override final deduction or uncheck to skip this month.</p></div>
        </div>
        <div className="sp-body">
          <div style={{"border":"1px solid var(--border)","borderRadius":"8px","overflow":"hidden"}}>
            <table className="stbl" id="loanTable">
              <thead>
                <tr>
                  <th>Employee</th><th>Type</th>
                  <th className="tr">Loan Amount</th>
                  <th className="tr">Repaid So Far</th>
                  <th className="tr">Tenure (Mo.)</th>
                  <th className="tr">Balance Tenure</th>
                  <th className="tr">EMI / Deduction</th>
                  <th className="tr">Final Deduction</th>
                  <th style="text-align:center">Deduct This Month</th>
                </tr>
              </thead>
              <tbody>
                {loans.map((loan, idx) => (
                  <tr key={idx}>
                    <td style={{fontWeight:'600'}}>{loan.name}<br/><code style={{fontSize:'10px',color:'var(--brand)'}}>{loan.eid}</code></td>
                    <td><span className="badge badge-account">{loan.type}</span></td>
                    <td className="tr">₹{loan.total.toLocaleString('en-IN')}</td>
                    <td className="tr">₹{loan.repaid.toLocaleString('en-IN')}</td>
                    <td className="tr">{loan.tenure} mo.</td>
                    <td className="tr">{loan.balTenure} mo.</td>
                    <td className="tr">₹{loan.emi.toLocaleString('en-IN')}</td>
                    <td className="tr"><input type="number" className="ii loan-final" defaultValue={loanFinals[idx]} onChange={(e) => handleLoanFinalChange(idx, parseInt(e.target.value))} style={{width:'60px'}}/></td>
                    <td style={{textAlign:'center'}}><input type="checkbox" className="cb loanChecks" checked={loanChecks[idx]} onChange={() => handleLoanCheckChange(idx)}/></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="6" className="fw-bold">Total</td>
                  <td className="tr fw-bold">₹{loanEmiTotal.toLocaleString('en-IN')}</td>
                  <td className="tr fw-bold text-brand">₹{loanFinalTotal.toLocaleString('en-IN')}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="step-nav">
        <button className="btn btn-light"  onClick={nextStep}><i className="fa-solid fa-arrow-left"></i> Back</button>
        <button className="btn btn-brand" onClick={prevStep}><i className="fa-solid fa-arrow-right"></i> Next: Arrears</button>
      </div>
          </div>
        )}


        {currentStep === 4 && (
          <div className={`step-panel ${currentStep === 4 ? 'active' : ''}`} id="step4">
           <div className="sp-card">
        <div className="sp-head">
          <div style="width:34px;height:34px;border-radius:50%;background:var(--brand-soft);display:flex;align-items:center;justify-content:center;color:var(--brand);font-weight:800">4</div>
          <div><h5>Arrears</h5><p>Salary arrears from previous months. Check to include in this payroll cycle.</p></div>
          <button className="btn btn-light btn-sm ms-auto" onclick="showAddArrear()"><i className="fa-solid fa-plus"></i> Add Arrear</button>
        </div>
        <div className="sp-body">
          <div style="border:1px solid var(--border);border-radius:8px;overflow:hidden">
            <table className="stbl">
              <thead>
                <tr>
                  <th>Employee</th><th>Arrear Type</th><th>For Month</th>
                  <th className="tr">Amount</th>
                  <th style="text-align:center">Status</th><th style="text-align:center">Include This Month</th>
                </tr>
              </thead>
              <tbody>
                {arrears.map((arrear, idx) => (
                  <tr key={idx}>
                    <td style={{fontWeight:'600'}}>{arrear.name}</td>
                    <td>{arrear.type}</td>
                    <td>{arrear.month}</td>
                    <td className="tr">₹{arrear.total.toLocaleString('en-IN')}</td>
                    <td style={{textAlign:'center'}}><span className={`badge badge-${arrear.status === 'Open' ? 'danger' : 'warning'}`}>{arrear.status}</span></td>
                    <td style={{textAlign:'center'}}><input type="checkbox" checked={arrearChecks[idx]} onChange={() => setArrearChecks(arrearChecks.map((c, i) => i === idx ? !c : c))}/></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3" className="fw-bold">Total Arrear (included)</td>
                  <td className="tr fw-bold text-brand">₹{arrearTotal.toLocaleString('en-IN')}</td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="step-nav">
        <button className="btn btn-light" onclick="prevStep()"><i className="fa-solid fa-arrow-left"></i> Back</button>
        <button className="btn btn-brand" onclick="nextStep()"><i className="fa-solid fa-arrow-right"></i> Next: Incentives</button>
      </div>
          </div>
        )}


        {currentStep === 5 && (
          <div className={`step-panel ${currentStep === 5 ? 'active' : ''}`} id="step5">
            <div className="sp-card">
        <div className="sp-head">
          <div style="width:34px;height:34px;border-radius:50%;background:var(--brand-soft);display:flex;align-items:center;justify-content:center;color:var(--brand);font-weight:800">5</div>
          <div><h5>Incentives &amp; Bonuses</h5><p>Open and partially paid incentives. Check to include in this payroll cycle.</p></div>
          <button className="btn btn-light btn-sm ms-auto" onclick="showAddIncentive()"><i className="fa-solid fa-plus"></i> Add Incentive</button>
        </div>
        <div className="sp-body">
          <div style="border:1px solid var(--border);border-radius:8px;overflow:hidden">
            <table className="stbl">
              <thead>
                <tr>
                  <th>Employee</th><th>Type</th><th>Description</th>
                  <th className="tr">Amount</th>
                  <th style="text-align:center">Status</th><th style="text-align:center">Include This Month</th>
                </tr>
              </thead>
              <tbody>
                {incentives.map((incent, idx) => (
                  <tr key={idx}>
                    <td style={{fontWeight:'600'}}>{incent.name}</td>
                    <td>{incent.type}</td>
                    <td>{incent.desc}</td>
                    <td className="tr">₹{incent.total.toLocaleString('en-IN')}</td>
                    <td style={{textAlign:'center'}}><span className={`badge badge-${incent.status === 'Open' ? 'warning' : 'info'}`}>{incent.status}</span></td>
                    <td style={{textAlign:'center'}}><input type="checkbox" checked={incentChecks[idx]} onChange={() => setIncentChecks(incentChecks.map((c, i) => i === idx ? !c : c))}/></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="3" className="fw-bold">Total Incentive (included)</td>
                  <td className="tr fw-bold text-brand">₹{incentTotal.toLocaleString('en-IN')}</td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="step-nav">
        <button className="btn btn-light" onclick="prevStep()"><i className="fa-solid fa-arrow-left"></i> Back</button>
        <button className="btn btn-brand" onclick="nextStep()"><i className="fa-solid fa-arrow-right"></i> Next: Reimbursements</button>
      </div>
          </div>
        )}


        {currentStep === 6 && (
          <div className={`step-panel ${currentStep === 6 ? 'active' : ''}`} id="step6">
             <div className="sp-card">
        <div className="sp-head">
          <div style="width:34px;height:34px;border-radius:50%;background:var(--brand-soft);display:flex;align-items:center;justify-content:center;color:var(--brand);font-weight:800">6</div>
          <div><h5>Reimbursements</h5><p>Individual reimbursement claims. Multiple claims per employee are consolidated in the summary. Check to include.</p></div>
          <button className="btn btn-light btn-sm ms-auto" onclick="showAddReimb()"><i className="fa-solid fa-plus"></i> Add Claim</button>
        </div>
        <div className="sp-body">
          <div style="border:1px solid var(--border);border-radius:8px;overflow:hidden">
            <table className="stbl">
              <thead>
                <tr>
                  <th>Employee</th><th>Description / Notes</th>
                  <th className="tr">Amount</th><th style="text-align:center">Include This Month</th>
                </tr>
              </thead>
              <tbody>
                {reimbs.map((reimb, idx) => (
                  <tr key={idx}>
                    <td style={{fontWeight:'600'}}>{reimb.name}</td>
                    <td>{reimb.type} - {reimb.desc}</td>
                    <td className="tr">₹{reimb.amount.toLocaleString('en-IN')}</td>
                    <td style={{textAlign:'center'}}><input type="checkbox" checked={reimbChecks[idx]} onChange={() => setReimbChecks(reimbChecks.map((c, i) => i === idx ? !c : c))}/></td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="2" className="fw-bold">Total Reimbursement (included)</td>
                  <td className="tr fw-bold text-brand">₹{reimbTotal.toLocaleString('en-IN')}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="step-nav">
        <button className="btn btn-light" onclick="prevStep()"><i className="fa-solid fa-arrow-left"></i> Back</button>
        <button className="btn btn-brand" onclick="nextStep()"><i className="fa-solid fa-arrow-right"></i> Next: Review</button>
      </div>
          </div>
        )}


        {currentStep === 7 && (
          <div className={`step-panel ${currentStep === 7 ? 'active' : ''}`} id="step7">
           <div className="sp-card">
        <div className="sp-head">
          <div style="width:34px;height:34px;border-radius:50%;background:var(--brand-soft);display:flex;align-items:center;justify-content:center;color:var(--brand);font-weight:800">7</div>
          <div><h5>Review Before Finalisation</h5><p>Verify all computed values. Set payment mode per employee. Proceed to generate the Salary Register.</p></div>
        </div>
        <div className="sp-body">
          <div style="display:flex;align-items:center;gap:10px;margin-bottom:12px">
            <span style="font-size:12px;color:var(--text-muted)">Showing <strong id="rv-showing">1–10</strong> of <strong id="rv-total-count">0</strong> employees</span>
            <div style="margin-left:auto;display:flex;gap:6px;align-items:center">
              <button className="btn btn-light btn-sm" id="rv-prev" onclick="reviewPage(-1)" disabled><i className="fa-solid fa-chevron-left"></i></button>
              <span style="font-size:12px;font-weight:600" id="rv-page-label">Page 1</span>
              <button className="btn btn-light btn-sm" id="rv-next" onclick="reviewPage(1)"><i className="fa-solid fa-chevron-right"></i></button>
            </div>
          </div>
          <div style="overflow-x:auto">
            <table className="stbl" id="reviewTable">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th className="tr">Days</th>
                  <th className="tr">Base Salary</th>
                  <th className="tr">Salary This Month</th>
                  <th className="tr">PF (EE)</th>
                  <th className="tr">ESIC (EE)</th>
                  <th className="tr">Arrear</th>
                  <th className="tr">Incentive</th>
                  <th className="tr">Reimb.</th>
                  <th className="tr">Loan Ded.</th>
                  <th className="tr">Other Ded.</th>
                  <th className="tr">TDS</th>
                  <th className="tr" style="color:var(--brand)">Final Payable</th>
                  <th style="text-align:center">Pay Decision</th>
                </tr>
              </thead>
              <tbody>
                {renderReviewPage()}
              </tbody>
              <tfoot>
                <tr>
                  <td className="fw-bold">TOTAL</td>
                  <td>—</td>
                  <td id="rv-base" className="tr fw-bold">—</td>
                  <td id="rv-salary" className="tr fw-bold">—</td>
                  <td id="rv-pf" className="tr fw-bold">—</td>
                  <td id="rv-esic" className="tr fw-bold">—</td>
                  <td id="rv-arrear" className="tr fw-bold" style="color:var(--success)">—</td>
                  <td id="rv-incent" className="tr fw-bold" style="color:var(--success)">—</td>
                  <td id="rv-reimb" className="tr fw-bold" style="color:var(--success)">—</td>
                  <td id="rv-loan" className="tr fw-bold" style="color:var(--danger)">—</td>
                  <td id="rv-other" className="tr fw-bold" style="color:var(--danger)">—</td>
                  <td id="rv-tds" className="tr fw-bold" style="color:var(--danger)">—</td>
                  <td id="rv-net" className="tr fw-bold" style="color:var(--brand);font-size:13px">—</td>
                  <td>—</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="step-nav">
        <button className="btn btn-light" onclick="prevStep()"><i className="fa-solid fa-arrow-left"></i> Back</button>
        <button className="btn btn-brand" onclick="nextStep()">
          <i className="fa-solid fa-check-double"></i> Finalise &amp; Go to Salary Register
        </button>
      </div>
          </div>
        )}


        {currentStep === 8 && (
          <div className={`step-panel ${currentStep === 8 ? 'active' : ''}`} id="step8">
           <div className="sp-card">
        <div className="sp-head">
          <div style="width:34px;height:34px;border-radius:50%;background:var(--brand-soft);display:flex;align-items:center;justify-content:center;color:var(--brand);font-weight:800">8</div>
          <div><h5>Salary Register</h5><p>Final computed register. Approve to enable disbursement.</p></div>
          <div style="margin-left:auto;display:flex;gap:8px;align-items:center">
            <button className="btn btn-light btn-sm" onclick="openHistory()">
              <i className="fa-solid fa-circle-info"></i> Process Summary
            </button>
            <button className="btn btn-light btn-sm" onclick="downloadExcel()">
              <i className="fa-solid fa-file-excel"></i> Export Excel
            </button>
            <button className="btn btn-light btn-sm" onclick="downloadBank()">
              <i className="fa-solid fa-building-columns"></i> Bank Format
            </button>
            <button className="btn btn-success btn-sm" id="approveBtn" onclick="approvePayroll()">
              <i className="fa-solid fa-circle-check"></i> Approve Payroll
            </button>
            <a href="salary-register.html" className="btn btn-brand btn-sm" id="viewRegisterBtn" style="display:none">
              <i className="fa-solid fa-table"></i> View Full Salary Register
            </a>
          </div>
        </div>
        <div className="sp-body" style="padding:0">
          <div style="display:flex;gap:0;border-bottom:1px solid var(--border);background:#fafbfc">
            <div style="padding:12px 20px;border-right:1px solid var(--border)">
              <div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.4px">Employees</div>
              <div style="font-size:18px;font-weight:800" id="reg-emp">—</div>
            </div>
            <div style="padding:12px 20px;border-right:1px solid var(--border)">
              <div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.4px">Gross</div>
              <div style="font-size:18px;font-weight:800;color:var(--info)" id="reg-gross">—</div>
            </div>
            <div style="padding:12px 20px;border-right:1px solid var(--border)">
              <div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.4px">Total Deductions</div>
              <div style="font-size:18px;font-weight:800;color:var(--danger)" id="reg-ded">—</div>
            </div>
            <div style="padding:12px 20px;border-right:1px solid var(--border)">
              <div style="font-size:10px;font-weight:700;color:var(--text-muted);text-transform:uppercase;letter-spacing:.4px">Net Payable</div>
              <div style="font-size:18px;font-weight:800;color:var(--brand)" id="reg-net">—</div>
            </div>
            <div style="padding:12px 20px;margin-left:auto;display:flex;align-items:center">
              <span className="badge badge-pending" id="reg-status"><i className="fa-regular fa-clock"></i> Pending Approval</span>
            </div>
          </div>
          <div style="overflow-x:auto">
            <table className="stbl" id="regTable">
              <thead>
                <tr>
                  <th>Emp ID</th><th>Name</th><th>Dept / Role</th>
                  <th className="tr">Days</th><th className="tr">Base Salary</th>
                  <th className="tr">Salary This Month</th>
                  <th className="tr">Arrear</th><th className="tr">Incentive</th><th className="tr">Reimb.</th>
                  <th className="tr">Total Gross</th>
                  <th className="tr">PF (EE)</th><th className="tr">ESIC (EE)</th><th className="tr">PT</th><th className="tr">TDS</th>
                  <th className="tr">Loan Ded.</th><th className="tr">Others</th>
                  <th className="tr" style="color:var(--brand);font-weight:800">Net Payable</th>
                  <th style="text-align:center">Pay Mode</th><th style="text-align:center">Slip</th>
                </tr>
              </thead>
              <tbody>
                {buildRegister()}
              </tbody>
              <tfoot>
                <tr>
                  <td colspan="3" className="fw-bold">TOTALS</td>
                  <td>—</td>
                  <td id="rg-base" className="tr fw-bold">—</td>
                  <td id="rg-salary" className="tr fw-bold">—</td>
                  <td id="rg-arrear" className="tr fw-bold" style="color:var(--success)">—</td>
                  <td id="rg-incent" className="tr fw-bold" style="color:var(--success)">—</td>
                  <td id="rg-reimb" className="tr fw-bold" style="color:var(--success)">—</td>
                  <td id="rg-gross" className="tr fw-bold">—</td>
                  <td id="rg-pf" className="tr fw-bold">—</td>
                  <td id="rg-esic" className="tr fw-bold">—</td>
                  <td id="rg-pt" className="tr fw-bold">—</td>
                  <td id="rg-tds" className="tr fw-bold" style="color:var(--danger)">—</td>
                  <td id="rg-loan" className="tr fw-bold">—</td>
                  <td id="rg-others" className="tr fw-bold">—</td>
                  <td id="rg-net" className="tr fw-bold" style="color:var(--brand);font-size:13px">—</td>
                  <td>—</td><td>—</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div className="step-nav">
        <button className="btn btn-light" onclick="prevStep()"><i className="fa-solid fa-arrow-left"></i> Back to Review</button>
      </div>
          </div>
        )} */}

        {currentStep === 2 && (
          <div className={`step-panel ${currentStep === 2 ? 'active' : ''}`} id="step2">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  2
                </div>
                <div>
                  <h5>Attendance &amp; LOP</h5>
                  <p>Sync attendance data to compute payable days. Skip to consider all 31 days for all employees.</p>
                </div>
                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <span style={{ fontSize: '12.5px', fontWeight: '600', color: 'var(--text-mid)' }}>
                    Skip attendance (pay full days)
                  </span>
                  <label className="tog">
                    <input
                      type="checkbox"
                      id="skipAtt"
                      onChange={toggleAttSync}
                    />
                    <span className="tog-slider"></span>
                  </label>
                </div>
              </div>

              <div className="sp-body" id="attBody">
                <div id="attSyncPanel">
                  <div style={{ display: 'flex', gap: '10px', marginBottom: '16px', alignItems: 'center' }}>
                    <button className="btn btn-brand btn-sm" onClick={syncAttendance}>
                      <i className="fa-solid fa-rotate"></i> Sync Attendance Data
                    </button>
                    <span style={{ fontSize: '12px', color: 'var(--text-muted)' }} id="attSyncStatus">
                      Not yet synced
                    </span>
                  </div>

                  <div id="attSummaryRow" style={{ display: 'none', gap: '12px', marginBottom: '18px' }} className="d-flex">
                    <div className="stat-box" style={{ borderLeft: '3px solid var(--success)' }}>
                      <div className="stat-box-label">Full Attendance</div>
                      <div className="stat-box-val" id="att-full">—</div>
                    </div>
                    <div className="stat-box" style={{ borderLeft: '3px solid var(--danger)' }}>
                      <div className="stat-box-label">With LOP</div>
                      <div className="stat-box-val" style={{ color: 'var(--danger)' }} id="att-lop">—</div>
                    </div>
                    <div className="stat-box" style={{ borderLeft: '3px solid var(--info)' }}>
                      <div className="stat-box-label">On Leave</div>
                      <div className="stat-box-val" id="att-leave">—</div>
                    </div>
                    <div className="stat-box" style={{ borderLeft: '3px solid var(--brand)' }}>
                      <div className="stat-box-label">Total LOP Days</div>
                      <div className="stat-box-val text-brand" id="att-lop-days">—</div>
                    </div>
                  </div>

                  <div id="attLopGrid" style={{ display: 'none' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                      <h6 style={{ margin: '0', fontSize: '13px', fontWeight: '700' }}>
                        <i className="fa-solid fa-calendar-xmark me-1 text-brand"></i>
                        LOP Records (Finalized)
                      </h6>
                      <span style={{ fontSize: '11.5px', color: 'var(--text-muted)' }}>
                        Remove any record to exclude it from LOP calculation
                      </span>
                    </div>
                    <div style={{ border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
                      <table className="stbl" id="lopTable">
                        <thead>
                          <tr>
                            <th>Employee</th>
                            <th>Department</th>
                            <th>LOP Date(s)</th>
                            <th>Days</th>
                            <th>Reason</th>
                            <th style={{ textAlign: 'center' }}>Remove</th>
                          </tr>
                        </thead>
                        <tbody id="lopBody"></tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div id="attSkipPanel" style={{ display: 'none' }}>
                  <div className="alert alert-info">
                    <i className="fa-solid fa-circle-info"></i> Attendance skipped — all <strong>31 days</strong> will be considered as payable days for all employees. No LOP will be applied.
                  </div>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-arrow-right"></i> Next: Loans &amp; Advances
              </button>
            </div>
          </div>
        )}

        {currentStep === 3 && (
          <div className={`step-panel ${currentStep === 3 ? 'active' : ''}`} id="step3">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  3
                </div>
                <div>
                  <h5>Loans &amp; Advances</h5>
                  <p>Each loan and advance shown separately. Override final deduction or uncheck to skip this month.</p>
                </div>
              </div>

              <div className="sp-body">
                <div style={{ border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
                  <table className="stbl" id="loanTable">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Type</th>
                        <th className="tr">Loan Amount</th>
                        <th className="tr">Repaid So Far</th>
                        <th className="tr">Tenure (Mo.)</th>
                        <th className="tr">Balance Tenure</th>
                        <th className="tr">EMI / Deduction</th>
                        <th className="tr">Final Deduction</th>
                        <th style={{ textAlign: 'center' }}>Deduct This Month</th>
                      </tr>
                    </thead>
                    <tbody id="loanBody"></tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="6" className="fw-bold">Total</td>
                        <td className="tr fw-bold" id="loan-emi-total">—</td>
                        <td className="tr fw-bold text-brand" id="loan-final-total">—</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-arrow-right"></i> Next: Arrears
              </button>
            </div>
          </div>
        )}

        {currentStep === 4 && (
          <div className={`step-panel ${currentStep === 4 ? 'active' : ''}`} id="step4">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  4
                </div>
                <div>
                  <h5>Arrears</h5>
                  <p>Salary arrears from previous months. Check to include in this payroll cycle.</p>
                </div>
                <button className="btn btn-light btn-sm ms-auto" onClick={showAddArrear}>
                  <i className="fa-solid fa-plus"></i> Add Arrear
                </button>
              </div>

              <div className="sp-body">
                <div style={{ border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
                  <table className="stbl">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Arrear Type</th>
                        <th>For Month</th>
                        <th className="tr">Amount</th>
                        <th style={{ textAlign: 'center' }}>Status</th>
                        <th style={{ textAlign: 'center' }}>Include This Month</th>
                      </tr>
                    </thead>
                    <tbody>
                      {arrears.map((arrear, idx) => (
                        <tr key={idx}>
                          <td style={{ fontWeight: '600' }}>{arrear.name}</td>
                          <td><span className="badge badge-account">{arrear.type}</span></td>
                          <td>{arrear.month}</td>
                          <td className="tr">₹{arrear.total.toLocaleString('en-IN')}</td>
                          <td style={{ textAlign: 'center' }}><span className={`badge badge-${arrear.status === 'Open' ? 'pending' : 'locked'}`}>{arrear.status}</span></td>
                          <td style={{ textAlign: 'center' }}><input type="checkbox" checked={arrearChecks[idx]} onChange={() => setArrearChecks(arrearChecks.map((c, i) => i === idx ? !c : c))} /></td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="3" className="fw-bold">Total Arrear (included)</td>
                        <td className="tr fw-bold text-brand">₹{arrearTotal.toLocaleString('en-IN')}</td>
                        <td colSpan="2"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-arrow-right"></i> Next: Incentives
              </button>
            </div>
          </div>
        )}

        {currentStep === 5 && (
          <div className={`step-panel ${currentStep === 5 ? 'active' : ''}`} id="step5">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  5
                </div>
                <div>
                  <h5>Incentives &amp; Bonuses</h5>
                  <p>Open and partially paid incentives. Check to include in this payroll cycle.</p>
                </div>
                <button className="btn btn-light btn-sm ms-auto" onClick={showAddIncentive}>
                  <i className="fa-solid fa-plus"></i> Add Incentive
                </button>
              </div>

              <div className="sp-body">
                <div style={{ border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
                  <table className="stbl">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th className="tr">Amount</th>
                        <th style={{ textAlign: 'center' }}>Status</th>
                        <th style={{ textAlign: 'center' }}>Include This Month</th>
                      </tr>
                    </thead>
                    <tbody>
                      {incentives.map((incent, idx) => (
                        <tr key={idx}>
                          <td style={{ fontWeight: '600' }}>{incent.name}</td>
                          <td><span className="badge badge-active">{incent.type}</span></td>
                          <td>{incent.desc}</td>
                          <td className="tr">₹{incent.total.toLocaleString('en-IN')}</td>
                          <td style={{ textAlign: 'center' }}><span className={`badge badge-${incent.status === 'Open' ? 'pending' : 'locked'}`}>{incent.status}</span></td>
                          <td style={{ textAlign: 'center' }}><input type="checkbox" checked={incentChecks[idx]} onChange={() => setIncentChecks(incentChecks.map((c, i) => i === idx ? !c : c))} /></td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="3" className="fw-bold">Total Incentive (included)</td>
                        <td className="tr fw-bold text-brand">₹{incentTotal.toLocaleString('en-IN')}</td>
                        <td colSpan="2"></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-arrow-right"></i> Next: Reimbursements
              </button>
            </div>
          </div>
        )}

        {currentStep === 6 && (
          <div className={`step-panel ${currentStep === 6 ? 'active' : ''}`} id="step6">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  6
                </div>
                <div>
                  <h5>Reimbursements</h5>
                  <p>Individual reimbursement claims. Multiple claims per employee are consolidated in the summary. Check to include.</p>
                </div>
                <button className="btn btn-light btn-sm ms-auto" onClick={showAddReimb}>
                  <i className="fa-solid fa-plus"></i> Add Claim
                </button>
              </div>

              <div className="sp-body">
                <div style={{ border: '1px solid var(--border)', borderRadius: '8px', overflow: 'hidden' }}>
                  <table className="stbl">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th>Description / Notes</th>
                        <th className="tr">Amount</th>
                        <th style={{ textAlign: 'center' }}>Include This Month</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(() => {
                        const grouped = {};
                        reimbs.forEach((r, i) => {
                          if (!grouped[r.name]) grouped[r.name] = [];
                          grouped[r.name].push({ ...r, idx: i });
                        });

                        const rows = [];
                        Object.entries(grouped).forEach(([empName, claims]) => {
                          const empTotal = claims.reduce((a, c) => a + c.amount, 0);
                          const empChecked = claims.some(c => reimbChecks[c.idx]);
                          
                          // Employee group header
                          rows.push(
                            <tr key={`header-${empName}`} style={{ background: '#f8f9fa', borderBottom: '2px solid var(--border)' }}>
                              <td style={{ fontWeight: '600', padding: '8px 12px' }}>
                                <strong>{empName}</strong>
                                <span style={{ fontSize: '11px', color: 'var(--text-muted)', marginLeft: '6px' }}>
                                  {claims.length} claim{claims.length > 1 ? 's' : ''}
                                </span>
                              </td>
                              <td></td>
                              <td style={{ textAlign: 'right', fontWeight: '700', color: 'var(--brand)', paddingRight: '12px' }}>
                                ₹{empTotal.toLocaleString('en-IN')}
                              </td>
                              <td></td>
                            </tr>
                          );

                          // Individual claim rows
                          claims.forEach(({ idx, ...claim }) => {
                            rows.push(
                              <tr key={`claim-${idx}`} style={{ background: '#fff' }}>
                                <td style={{ paddingLeft: '30px', fontSize: '12px', color: 'var(--text-muted)' }}>{claim.type}</td>
                                <td style={{ paddingLeft: '30px', fontSize: '12px', color: 'var(--text-muted)' }}>{claim.desc}</td>
                                <td className="tr">₹{claim.amount.toLocaleString('en-IN')}</td>
                                <td style={{ textAlign: 'center' }}>
                                  <input type="checkbox" checked={reimbChecks[idx]} onChange={() => setReimbChecks(reimbChecks.map((c, i) => i === idx ? !c : c))} />
                                </td>
                              </tr>
                            );
                          });
                        });

                        return rows;
                      })()}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="2" className="fw-bold">Total Reimbursement (included)</td>
                        <td className="tr fw-bold text-brand">₹{reimbTotal.toLocaleString('en-IN')}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-arrow-right"></i> Next: Review
              </button>
            </div>
          </div>
        )}

        {currentStep === 7 && (
          <div className={`step-panel ${currentStep === 7 ? 'active' : ''}`} id="step7">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  7
                </div>
                <div>
                  <h5>Review Before Finalisation</h5>
                  <p>Verify all computed values. Set payment mode per employee. Proceed to generate the Salary Register.</p>
                </div>
              </div>

              <div className="sp-body">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                  <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
                    Showing <strong id="rv-showing">1–10</strong> of <strong id="rv-total-count">0</strong> employees
                  </span>
                  <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px', alignItems: 'center' }}>
                    <button className="btn btn-light btn-sm" id="rv-prev" onClick={() => reviewPage(-1)} disabled>
                      <i className="fa-solid fa-chevron-left"></i>
                    </button>
                    <span style={{ fontSize: '12px', fontWeight: '600' }} id="rv-page-label">Page 1</span>
                    <button className="btn btn-light btn-sm" id="rv-next" onClick={() => reviewPage(1)}>
                      <i className="fa-solid fa-chevron-right"></i>
                    </button>
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="stbl" id="reviewTable">
                    <thead>
                      <tr>
                        <th>Employee</th>
                        <th className="tr">Days</th>
                        <th className="tr">Base Salary</th>
                        <th className="tr">Salary This Month</th>
                        <th className="tr">PF (EE)</th>
                        <th className="tr">ESIC (EE)</th>
                        <th className="tr">Arrear</th>
                        <th className="tr">Incentive</th>
                        <th className="tr">Reimb.</th>
                        <th className="tr">Loan Ded.</th>
                        <th className="tr">Other Ded.</th>
                        <th className="tr">TDS</th>
                        <th className="tr" style={{ color: 'var(--brand)' }}>Final Payable</th>
                        <th style={{ textAlign: 'center' }}>Pay Decision</th>
                      </tr>
                    </thead>
                    <tbody>
                      {renderReviewPage()}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td className="fw-bold">TOTAL</td>
                        <td>31</td>
                        <td className="tr fw-bold">₹{reviewData.reduce((sum, row) => sum + (row.e.base || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{reviewData.reduce((sum, row) => sum + (row.e.salary || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{reviewData.reduce((sum, row) => sum + (row.e.pf_ee || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{reviewData.reduce((sum, row) => sum + (row.e.esic_ee || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--success)' }}>₹{reviewData.reduce((sum, row) => sum + (row.arr || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--success)' }}>₹{reviewData.reduce((sum, row) => sum + (row.inc || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--success)' }}>₹{reviewData.reduce((sum, row) => sum + (row.rei || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--danger)' }}>₹{reviewData.reduce((sum, row) => sum + (row.loan || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--danger)' }}>₹{reviewData.reduce((sum, row) => sum + (row.other || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--danger)' }}>₹{reviewData.reduce((sum, row) => sum + (row.e.tds || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--brand)', fontSize: '13px' }}>₹{reviewData.reduce((sum, row) => sum + (row.net || 0), 0).toLocaleString('en-IN')}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back
              </button>
              <button className="btn btn-brand" onClick={nextStep}>
                <i className="fa-solid fa-check-double"></i> Finalise &amp; Go to Salary Register
              </button>
            </div>
          </div>
        )}

        {currentStep === 8 && (
          <div className={`step-panel ${currentStep === 8 ? 'active' : ''}`} id="step8">
            <div className="sp-card">
              <div className="sp-head">
                <div
                  style={{
                    width: '34px',
                    height: '34px',
                    borderRadius: '50%',
                    background: 'var(--brand-soft)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'var(--brand)',
                    fontWeight: '800'
                  }}
                >
                  8
                </div>
                <div>
                  <h5>Salary Register</h5>
                  <p>Final computed register. Approve to enable disbursement.</p>
                </div>
                <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <button className="btn btn-light btn-sm" onClick={openHistory}>
                    <i className="fa-solid fa-circle-info"></i> Process Summary
                  </button>
                  <button className="btn btn-light btn-sm" onClick={downloadExcel}>
                    <i className="fa-solid fa-file-excel"></i> Export Excel
                  </button>
                  <button className="btn btn-light btn-sm" onClick={downloadBank}>
                    <i className="fa-solid fa-building-columns"></i> Bank Format
                  </button>
                  <button className="btn btn-success btn-sm" id="approveBtn" onClick={approvePayroll}>
                    <i className="fa-solid fa-circle-check"></i> Approve Payroll
                  </button>
                  <a
                    href="salary-register.html"
                    className="btn btn-brand btn-sm"
                    id="viewRegisterBtn"
                    style={{ display: 'none' }}
                  >
                    <i className="fa-solid fa-table"></i> View Full Salary Register
                  </a>
                </div>
              </div>

              <div className="sp-body" style={{ padding: 0 }}>
                <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid var(--border)', background: '#fafbfc' }}>
                  <div style={{ padding: '12px 20px', borderRight: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '10px', fontWeight: '700', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px' }}>
                      Employees
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '800' }} id="reg-emp">—</div>
                  </div>
                  <div style={{ padding: '12px 20px', borderRight: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '10px', fontWeight: '700', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px' }}>
                      Gross
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--info)' }} id="reg-gross">—</div>
                  </div>
                  <div style={{ padding: '12px 20px', borderRight: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '10px', fontWeight: '700', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px' }}>
                      Total Deductions
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--danger)' }} id="reg-ded">—</div>
                  </div>
                  <div style={{ padding: '12px 20px', borderRight: '1px solid var(--border)' }}>
                    <div style={{ fontSize: '10px', fontWeight: '700', color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.4px' }}>
                      Net Payable
                    </div>
                    <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--brand)' }} id="reg-net">—</div>
                  </div>
                  <div style={{ padding: '12px 20px', marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                    <span className="badge badge-pending" id="reg-status">
                      <i className="fa-regular fa-clock"></i> Pending Approval
                    </span>
                  </div>
                </div>

                <div style={{ overflowX: 'auto' }}>
                  <table className="stbl" id="regTable">
                    <thead>
                      <tr>
                        <th>Emp ID</th>
                        <th>Name</th>
                        <th>Dept / Role</th>
                        <th className="tr">Days</th>
                        <th className="tr">Base Salary</th>
                        <th className="tr">Salary This Month</th>
                        <th className="tr">Arrear</th>
                        <th className="tr">Incentive</th>
                        <th className="tr">Reimb.</th>
                        <th className="tr">Total Gross</th>
                        <th className="tr">PF (EE)</th>
                        <th className="tr">ESIC (EE)</th>
                        <th className="tr">PT</th>
                        <th className="tr">TDS</th>
                        <th className="tr">Loan Ded.</th>
                        <th className="tr">Others</th>
                        <th className="tr" style={{ color: 'var(--brand)', fontWeight: '800' }}>Net Payable</th>
                        <th style={{ textAlign: 'center' }}>Pay Mode</th>
                        <th style={{ textAlign: 'center' }}>Slip</th>
                      </tr>
                    </thead>
                    <tbody>
                      {buildRegister()}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan="3" className="fw-bold">TOTALS</td>
                        <td>31</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.base || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.salary || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--success)' }}>₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (arrears.filter(a => a.eid === e.eid).reduce((s, a) => s + a.total, 0)), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--success)' }}>₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (incentives.filter(v => v.eid === e.eid).reduce((s, v) => s + v.total, 0)), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--success)' }}>₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (reimbs.filter(r => r.eid === e.eid).reduce((s, r) => s + r.amount, 0)), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.salary || 0) + (arrears.filter(a => a.eid === e.eid).reduce((s, a) => s + a.total, 0)) + (incentives.filter(v => v.eid === e.eid).reduce((s, v) => s + v.total, 0)) + (reimbs.filter(r => r.eid === e.eid).reduce((s, r) => s + r.amount, 0)), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.pf_ee || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.esic_ee || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.pt || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--danger)' }}>₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.tds || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (loans.filter(l => l.eid === e.eid).reduce((s, l) => s + l.emi, 0)), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold">₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => sum + (e.food || 0), 0).toLocaleString('en-IN')}</td>
                        <td className="tr fw-bold" style={{ color: 'var(--brand)', fontSize: '13px' }}>₹{employees.filter(e => !excluded[e.eid]).reduce((sum, e) => {
                          const arrearAmt = arrears.filter(a => a.eid === e.eid).reduce((a, v) => a + v.total, 0) || 0;
                          const incentAmt = incentives.filter(v => v.eid === e.eid).reduce((a, v) => a + v.total, 0) || 0;
                          const reimbAmt = reimbs.filter(r => r.eid === e.eid).reduce((a, r) => a + r.amount, 0) || 0;
                          const loanAmt = loans.filter(l => l.eid === e.eid).reduce((a, l) => a + l.emi, 0) || 0;
                          const grossSalary = (e.salary || 0) + arrearAmt + incentAmt + reimbAmt;
                          const netPayable = grossSalary - (e.pf_ee || 0) - (e.esic_ee || 0) - (e.pt || 0) - (e.tds || 0) - loanAmt;
                          return sum + netPayable;
                        }, 0).toLocaleString('en-IN')}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            <div className="step-nav">
              <button className="btn btn-light" onClick={prevStep}>
                <i className="fa-solid fa-arrow-left"></i> Back to Review
              </button>
            </div>
          </div>
        )}

        {/* Steps 3 to 8 would follow the same conversion pattern */}
        {/* Due to length, I've shown the complete conversion approach for the first two steps. The rest can be converted similarly using React state for all dynamic parts. */}

        {/* Navigation is handled via currentStep state */}

      </div>
      {/* Modals - converted to React controlled components */}
      {/* Arrear Modal, Incentive Modal, Reimb Modal, History Modal, Warning Modal - all use state for visibility */}

      {/* Example Arrear Modal */}
      {showArrearModal && (
        <div className="modal-overlay open" onClick={() => closeModal(setShowArrearModal)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            {/* Modal content same as original */}
            <div className="modal-head">
              <i className="fa-solid fa-plus-circle text-brand"></i>
              <h6 style={{ margin: '0', fontWeight: '700' }}>Add Arrear</h6>
              <button style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }} onClick={() => closeModal(setShowArrearModal)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="form-label">Employee *</label>
                  <select className="form-select w-100" id="ma-emp">
                    {employees.map(e => (
                      <option key={e.eid} value={e.eid}>{e.name} ({e.eid})</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Arrear Type *</label>
                  <select className="form-select w-100">
                    <option>Salary Revision</option>
                    <option>Backdated Increment</option>
                    <option>Missed Payment</option>
                    <option>Other</option>
                  </select>
                </div>
                <div><label className="form-label">For Month</label><select className="form-select w-100"><option>Feb 2025</option><option>Jan 2025</option><option>Dec 2024</option></select></div>
                <div><label className="form-label">Amount (₹) *</label><input type="number" className="form-control w-100" placeholder="0" id="ma-amount" /></div>

                {/* Other fields */}
              </div>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
                <button className="btn btn-light" onClick={() => closeModal(setShowArrearModal)}>Cancel</button>
                <button className="btn btn-brand" onClick={saveArrear}><i className="fa-solid fa-check"></i> Add Arrear</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Incentive Modal */}
      {showIncentModal && (
        <div className="modal-overlay open" onClick={() => closeModal(setShowIncentModal)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <i className="fa-solid fa-plus-circle text-brand"></i>
              <h6 style={{ margin: '0', fontWeight: '700' }}>Add Incentive</h6>
              <button style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }} onClick={() => closeModal(setShowIncentModal)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="form-label">Employee *</label>
                  <select className="form-select w-100" id="mi-emp">
                    {employees.map(e => (
                      <option key={e.eid} value={e.eid}>{e.name} ({e.eid})</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Incentive Type *</label>
                  <select className="form-select w-100">
                    <option>Performance Incentive</option>
                    <option>Variable Pay</option>
                    <option>Retention Bonus</option>
                    <option>Sales Commission</option>
                    <option>Other</option>
                  </select>
                </div>
                <div colSpan="2">
                  <label className="form-label">Description</label>
                  <input type="text" className="form-control" placeholder="e.g., Q4 FY24-25" />
                </div>
                <div>
                  <label className="form-label">Amount *</label>
                  <input type="number" className="form-control" id="mi-amount" placeholder="0" />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
                <button className="btn btn-light" onClick={() => closeModal(setShowIncentModal)}>Cancel</button>
                <button className="btn btn-brand" onClick={saveIncentive}><i className="fa-solid fa-check"></i> Add Incentive</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Reimbursement Modal */}
      {showReimbModal && (
        <div className="modal-overlay open" onClick={() => closeModal(setShowReimbModal)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <i className="fa-solid fa-plus-circle text-brand"></i>
              <h6 style={{ margin: '0', fontWeight: '700' }}>Add Reimbursement Claim</h6>
              <button style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }} onClick={() => closeModal(setShowReimbModal)}>×</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label className="form-label">Employee *</label>
                  <select className="form-select w-100" id="mr-emp">
                    {employees.map(e => (
                      <option key={e.eid} value={e.eid}>{e.name} ({e.eid})</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="form-label">Claim Type *</label>
                  <select className="form-select w-100">
                    <option>Meal</option>
                    <option>Internet</option>
                    <option>Fuel</option>
                    <option>Mobile</option>
                    <option>LTA</option>
                    <option>Books & Education</option>
                    <option>Other</option>
                  </select>
                </div>
                <div colSpan="2">
                  <label className="form-label">Description</label>
                  <input type="text" className="form-control" placeholder="e.g., Monthly meal" />
                </div>
                <div>
                  <label className="form-label">Amount *</label>
                  <input type="number" className="form-control" id="mr-amount" placeholder="0" />
                </div>
              </div>
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end', marginTop: '16px' }}>
                <button className="btn btn-light" onClick={() => closeModal(setShowReimbModal)}>Cancel</button>
                <button className="btn btn-brand" onClick={saveReimb}><i className="fa-solid fa-check"></i> Add Claim</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* History Modal */}
      {showHistoryModal && (
        <div className="modal-overlay open" onClick={() => closeModal(setShowHistoryModal)}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            <div className="modal-head">
              <i className="fa-solid fa-circle-info text-brand"></i>
              <h6 style={{ margin: '0', fontWeight: '700' }}>Process Summary</h6>
              <button style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }} onClick={() => closeModal(setShowHistoryModal)}>×</button>
            </div>
            <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
              {getHistoryContent()}
            </div>
            <div style={{ borderTop: '1px solid var(--border)', padding: '12px 20px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
              <button className="btn btn-brand" onClick={() => closeModal(setShowHistoryModal)}>Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Warning Modal */}
      {showWarnModal && (
        <div className="modal-overlay open" onClick={() => closeModal(setShowWarnModal)}>
          <div className="modal-box" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <div className="modal-head">
              <i className="fa-solid fa-triangle-exclamation" style={{ color: 'var(--warning)' }}></i>
              <h6 style={{ margin: '0', fontWeight: '700' }}>{warnTitle}</h6>
              <button style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }} onClick={() => closeModal(setShowWarnModal)}>×</button>
            </div>
            <div className="modal-body">
              <p style={{ margin: '0', color: 'var(--text-muted)', fontSize: '13px' }}>{warnMsg}</p>
            </div>
            <div style={{ borderTop: '1px solid var(--border)', padding: '12px 20px', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
              <button className="btn btn-light" onClick={() => closeModal(setShowWarnModal)}>Cancel</button>
              <button className="btn btn-warning" onClick={() => { warnOnOk?.(); closeModal(setShowWarnModal); }}>Proceed</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default RunPayroll;